module.exports = __webpack_public_path__ + "img/llamanos.349178d3.jpg";